import request from '../../request.js'
//e签宝 签署订单

//根据会员id等，获取订单历史信息 - 张卫华
export const getOrderHistoryByReIds = function (data) {
    return request({
        url: '/esignOrderHistory/getOrderHistoryByReIds',
        method: 'post',
        data
    })
}
//分页列表
export const getPageTableList = function (data) {
    return request({
        url: '/esignOrderHistory/getPageTableList',
        method: 'post',
        data
    })
}


//列表
export const getTableList = function (data) {
    return request({
        url: '/esignOrderHistory/getTableList',
        method: 'post',
        data
    })
}

//根据id，获取信息
export const getObjectById = function (data) {
    return request({
        url: '/esignOrderHistory/getObjectById',
        method: 'post',
        data
    })
}